import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';
import {
  replicateExistingTheme,
  clearReplicateExistingTheme,
} from 'redux/themes/actions';
import { fetchMe } from 'redux/users/actions';

import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonErrorIcon
  from 'components/common/CommonErrorIcon';

import ProSectionPlaceholder
  from 'components/common/pro-placeholders/ProSectionPlaceholder';

import validate from './validate';

import './ReplicateExistingTheme.css';

const ReplicateExistingTheme = ({
  handleSubmit,
  replicateExistingTheme,
  clearReplicateExistingTheme,
  fetchMe,
  reset,
  valid,
  replicateExistingThemeSuccess,
  replicateExistingThemeError,
  me,
  url,
}) => {

  useEffect(() => {
    return () => {
      clearReplicateExistingTheme();
    };
  }, []);

  useEffect(() => {
    if (replicateExistingThemeSuccess) {
      fetchMe();
    }
  }, [replicateExistingThemeSuccess]);

  const _handleSubmit = values => {
    let urlValue = values.url;
    if (me && me.subscription && me.subscription.ff_replicate) {
      replicateExistingTheme(urlValue);
      clearReplicateExistingTheme();
      reset();
    }
  };

  const handleError = error => {
    let errorText = 'Error';
    if ('non_field_errors' in error) {
      errorText = error.non_field_errors[0];
    }
    return errorText;
  };

  const { t } = useTranslation();

  return (
    <ProSectionPlaceholder
      key="replicate-existing-theme-pro-feature-key"
      locked={me && me.subscription && !me.subscription.ff_replicate}
      className="replicate-existing-theme__component"
      text={
        <>
          {t("You can copy the design of the existing HeyLink.me page on the PRO plan. Check it")}
        </>
      }
    >
      <div className={`replicate-existing-theme-container ${me && me.subscription && !me.subscription.ff_replicate ? 'lock' : ''}`}>
        <Form
          onSubmit={handleSubmit(_handleSubmit)}
          error={!valid}
        >
          <div className="replicate-existing-theme-wrapper">
              <div className="replicate-existing-theme-content">
                {/* Url */}
                <div className="field-wrapper">
                  <Field
                    component={TextField}
                    name="url"
                    type="text"
                    placeholder={t("Paste existing HeyLink.me here")}
                    required
                  />

                  {replicateExistingThemeError &&
                    <CommonErrorIcon
                      key="replicate-existing-theme"
                      errorId="replicate-existing-theme-error"
                      errorText={handleError(replicateExistingThemeError)}
                    />
                  }
                </div>
                <Button
                  submit
                  disabled={!valid || !url}
                >
                  {t("Replicate Theme")}
                </Button>
              </div>
          </div>
        </Form>
      </div>
    </ProSectionPlaceholder>
  );
};

ReplicateExistingTheme.propTypes = {
  handleSubmit: PropTypes.func,
  replicateExistingTheme: PropTypes.func,
  clearReplicateExistingTheme: PropTypes.func,
  fetchMe: PropTypes.func,
  reset: PropTypes.func,
  valid: PropTypes.bool,
  replicateExistingThemeSuccess: PropTypes.bool,
  replicateExistingThemeError: PropTypes.object,
  me: PropTypes.object,
  url: PropTypes.string,
};
ReplicateExistingTheme.defaultProps = {
  handleSubmit: null,
  replicateExistingTheme: null,
  clearReplicateExistingTheme: null,
  fetchMe: null,
  reset: null,
  valid: null,
  replicateExistingThemeSuccess: null,
  replicateExistingThemeError: null,
  me: null,
  url: null,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('ReplicateExistingThemeForm');
  return {
    url: selector(state, 'url'),
    replicateExistingThemeSuccess: state.themesReducer.replicateExistingThemeSuccess,
    replicateExistingThemeError: state.themesReducer.replicateExistingThemeError,
    me: state.usersReducer.me,
  };
};

export default connect(
  mapStateToProps,
  {
    replicateExistingTheme,
    clearReplicateExistingTheme,
    fetchMe,
  },
)(reduxForm({
  form: 'ReplicateExistingThemeForm',
  validate,
})(ReplicateExistingTheme));
